import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as NewsfeedQuicklinksActions from './newsfeed-quicklinks.actions';
import { loadQuicklinksFailure } from './newsfeed-quicklinks.actions';
import { Quicklink } from './newsfeed-quicklinks.models';

export const NEWSFEED_QUICKLINKS_FEATURE_KEY = 'newsfeedQuicklinks';

export interface NewsfeedQuicklinksState extends EntityState<Quicklink> {
  loaded: boolean;
  error?: string | null;
}

export interface NewsfeedQuicklinksPartialState {
  readonly [NEWSFEED_QUICKLINKS_FEATURE_KEY]: NewsfeedQuicklinksState;
}

export const newsfeedQuicklinksAdapter: EntityAdapter<Quicklink> = createEntityAdapter<Quicklink>();

export const initialNewsfeedQuicklinksState: NewsfeedQuicklinksState = newsfeedQuicklinksAdapter.getInitialState({
  loaded: false,
});

const reducer = createReducer(
  initialNewsfeedQuicklinksState,
  on(NewsfeedQuicklinksActions.loadQuicklinks, (state) => ({ ...state, loaded: false, error: null })),
  on(NewsfeedQuicklinksActions.loadQuicklinksSuccess, (state, { quicklinks }) =>
    newsfeedQuicklinksAdapter.setAll(quicklinks, { ...state, loaded: true })
  ),
  on(NewsfeedQuicklinksActions.loadTopTagsFailure, loadQuicklinksFailure, (state, { error }) => ({ ...state, error }))
);

export function newsfeedQuicklinksReducer(state: NewsfeedQuicklinksState | undefined, action: Action) {
  return reducer(state, action);
}
